module.exports = __webpack_public_path__ + "media/images/desktop/app-download-QRcode-ec0bfd67ffba09b7ba89dbab083ea92a.png";